import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover, PopoverSize } from '@as/cotopaxi';
import { ArrowLeftIcon, XIcon } from '@yonderland/andes-icons';
import { useIsClient, useMediaQueryMatchesOnMobile, useMediaQueryMatchesOnDesktop, Box, TextAlpha, IconButton, } from '@yonderland/andes-react';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ForgotPassword } from './ForgotPassword';
import { Login } from './Login';
export const Authentication = ({ forgotPassword, login, anchorEl, onClose, registrationLink, onAuthResetForm, inPopover, hideTitle = false, hasShadow = false, isInAuthorMode = false, resetForgotPasswordState, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const email = useRef('');
    const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
    const isMobile = useMediaQueryMatchesOnMobile();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isClient = useIsClient(isInAuthorMode);
    if (!isClient)
        return null;
    const toggleView = () => {
        setForgotPasswordActive(!forgotPasswordActive);
        resetForgotPasswordState === null || resetForgotPasswordState === void 0 ? void 0 : resetForgotPasswordState();
    };
    const handleForgotPasswordEmailChange = (value) => {
        email.current = value;
        resetForgotPasswordState === null || resetForgotPasswordState === void 0 ? void 0 : resetForgotPasswordState();
    };
    const title = forgotPasswordActive ? t('account.login.title.password.forgotten') : t('account.login.title.login');
    const renderContent = forgotPasswordActive ? (_jsx(ForgotPassword, Object.assign({}, forgotPassword, { initialEmail: email.current, backToLoginClicked: toggleView, onEmailChange: handleForgotPasswordEmailChange }))) : (_jsx(Login, { login: Object.assign(Object.assign({}, login), { forgotPasswordClicked: toggleView, initialEmail: email.current }), registrationLink: registrationLink, onAuthResetForm: onAuthResetForm }));
    return inPopover ? (_jsx(Popover, { dataQA: "login_popover", size: PopoverSize.LARGE, onClose: onClose, anchorEl: anchorEl, hasScrollLock: !isDesktop, title: title, rightElement: _jsx(IconButton, { onClick: onClose, variant: "plain", size: "sm", icon: { source: XIcon } }), leftElement: forgotPasswordActive ? (_jsx(IconButton, { onClick: toggleView, variant: "plain", size: "sm", icon: { source: ArrowLeftIcon } })) : null, children: renderContent })) : (_jsxs(Box, { marginInline: { base: '-4', md: '0' }, shadow: !isMobile || hasShadow ? 'lg' : undefined, backgroundColor: "quiet", paddingInline: {
            base: '4',
            md: '8',
            lg: '12',
        }, paddingBlockStart: {
            base: '6',
            md: '4',
            lg: '10',
        }, paddingBlockEnd: {
            base: '2',
            md: '6',
            lg: '8',
        }, children: [!hideTitle && (_jsx(Box, { paddingBlockEnd: { base: '4', lg: '6' }, children: _jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: title }) })), renderContent] }));
};
